import QuestionPreviewCard from 'organisms/QuestionPreviewCard'
import React, { useState } from 'react'
import { Button } from 'semantic-ui-react'
import { Loader } from 'shared/components/Loader'
import PromptTextArea from 'components/PromptTextArea'

export default function GenerateQuestion({ questions, loading, submitPrompt, setQuestions }) {
  const [prompt, setPrompt] = useState('')
  function onSelectQuestion(index, value) {
    const newQuestions = [...questions]

    newQuestions[index]['isSelected'] = value

    setQuestions(newQuestions)
  }

  return (
    <div className="flex flex-col sm:flex-row rounded" style={{ maxHeight: '550px' }}>
      <div className="p-6 w-full sm:w-1/3 bg-white rounded">
        <p>Enter a prompt, select from the AI-suggested questions, and fine-tune as needed.</p>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://help.simplesat.io/en/articles/2776705-survey-questions#generating-questions-with-ai"
          className=" mb-5"
        >
          <i className="icon far fa-book" />
          Learn more about AI generated questions
        </a>{' '}
        <PromptTextArea prompt={prompt} setPrompt={setPrompt} />
        <Button
          className="primary w-full"
          disabled={loading || prompt == ''}
          onClick={() => submitPrompt(prompt)}
        >
          Generate questions
        </Button>
      </div>
      <div
        className="p-6 !pt-0 w-full sm:w-2/3 bg-white rounded"
        style={{
          display: 'block',
          overflowY: 'auto',
        }}
      >
        {loading && <Loader withContainer containerHeight={'100%'} />}

        {questions &&
          questions.length > 0 &&
          questions.map((item, index) => {
            return (
              <QuestionPreviewCard
                key={index}
                question={item}
                onSelectQuestion={onSelectQuestion}
                keyIndex={index}
              />
            )
          })}
        {questions && questions.length == 0 && (
          <div className=" w-full h-full flex ">
            <div className="!m-auto text-[#A5ADBA]">
              <p className="font-bold text-[22px] ">Enter a prompt to generate new questions</p>
              <p>Examples:</p>
              <ul>
                <li>Questions for a CSAT survey after a solved support ticket</li>
                <li>Post project survey for an IT company</li>
                <li>Quarterly Net Promoter Score survey for a SaaS company</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/GenerateQuestion/index.js